import { Web3Transfer } from '../Web3/web3.types';

export type FrameProps = {
  url: string;
  className?: string;
  dataAttribute?: string;
  onLoad?: () => void;
  onReceiveMessage?: (data: MessageEvent<FrameEventType>, onReply: (params: unknown) => void) => void;
  params?: {
    [key: string]: string | number | undefined | boolean;
    currency?: string;
    amount?: string | number;
    symbol?: string;
    fromPage?: string;
  };
};

export enum FrameEvents {
  BACK = 'back',
  SUCCESS = 'success',
  HOME = 'home',
  WALLET = 'wallet',
  DEPOSIT_CRYPTO = 'deposit:crypto',
  EXCHANGE = 'exchange',
  BUY_CRYPTO = 'buyCrypto',
  SPOT = 'spot',
  VERIFICATION = 'verification',
  VERIFICATION_LEVELS = 'verification_levels',
  LOGOUT = 'logout',
  BALANCE_UPDATE = 'balance_update',
  LOYALTY = 'loyalty',
  CLOSE_POPUP = 'close_popup',
  GET_CRYPTOPAY_LINK = 'create_payment_link',
  REDIRECT_CRYPTOPAY = 'transaction_grid',
  RESIZE = 'frameResize', // lient-area mass payment iframe height

  // Web3
  WEB3_CONNECT = 'web3:connect',
  WEB3_SIGNIN = 'web3:signin',
  WEB3_SIGNOUT = 'web3:signout',
  WEB3_DISCONNECT = 'web3:disconnect',
  WEB3_TRANSFER = 'web3:transfer',

  // TOKEN PRE-SALE
  REDIRECT = 'redirect',
}

export type FrameEventType = Web3Transfer & {
  type: FrameEvents;
  amount?: number;
  currency?: string;
  url?: string;
  height?: number;
};
